module.exports = __webpack_public_path__ + "img/2center.04a2aada.png";